// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

//import logoSVG from "assets/images/LogoAina.svg";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Kode Cars Market",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/CreativeTim/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/creativetim",
    },
    {
      icon: <TwitterIcon />,
      link: "https://github.com/creativetimofficial",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
    },
  ],
  menus: [
    {
      name: "Contacto",
      items: [
        { name: "about us", href: "https://www.creative-tim.com/presentation" },
        { name: "freebies", href: "https://www.creative-tim.com/templates/free" },
        { name: "premium tools", href: "https://www.creative-tim.com/templates/premium" },
        { name: "blog", href: "https://www.creative-tim.com/blog" },
      ],
    },
    {
      name: "Horario",
      items: [
        { name: "illustrations", href: "https://iradesign.io/" },
        { name: "bits & snippets", href: "https://www.creative-tim.com/bits" },
        { name: "affiliate program", href: "https://www.creative-tim.com/affiliates/new" },
      ],
    },
    {
      name: "Grupo Ainacar",
      items: [
        { name: "AinaCar Wash", href: "https://www.creative-tim.com/contact-us" },
        { name: "AinaCar Protect", href: "https://www.creative-tim.com/knowledge-center" },
        { name: "FAQ. Preguntas frecuentes", href: "https://services.creative-tim.com/" },
        { name: "Aviso Legal", href: "https://www.creative-tim.com/sponsorships" },
        { name: "Política Gestión de daños", href: "https://www.creative-tim.com/contact-us" },
        { name: "Términos y Condiciones Generales", href: "https://www.creative-tim.com/knowledge-center" },
        { name: "Política de provacidad", href: "https://services.creative-tim.com/" },
        { name: "Política de cookies", href: "https://www.creative-tim.com/sponsorships" },
        { name: "Condiciones generales de contratación", href: "https://services.creative-tim.com/" },
        { name: "Imformación antes de alquiler", href: "https://www.creative-tim.com/sponsorships" },
      ],
    },
    
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} by{" "}
      <MKTypography
        component="a"
        href="https://www.creative-tim.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        AinaCar
      </MKTypography>
      .
    </MKTypography>
  ),
};
